module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page auth-login-page no-top-nav no-side-space"
  }, [_c('v-container', {
    attrs: {
      "grid-list-item": "",
      "allChildrenCenter": "",
      "auth-card": "",
      "px-0": "",
      "pb-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "auth-card-wrapper": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "auth-card-child": "",
      "left-card": "",
      "sign-in-info": ""
    }
  }, [(!_vm.onMobile) ? _c('div', [_c('img', {
    attrs: {
      "width": "40%",
      "src": "/static/images/nav_logo_primary.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 dflex align-center"
  }, [_c('h3', [_vm._v("Login")]), _vm._v(" "), _c('h3', {
    staticClass: "mx-3"
  }, [_vm._v("or")]), _vm._v(" "), _c('h3', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign Up")])], 1)])]) : _c('div', {
    staticClass: "text-xs-center create-btn-wrapper"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "transparent create-btn black--text",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "round": "",
      "depressed": "",
      "to": _vm.onMobile ? '/onboarding' : '/register'
    }
  }, [_vm._v("\n              Sign Up\n            ")])], 1), _vm._v(" "), (!_vm.onMobile) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (!_vm.onMobile) ? _c('div', {
    staticClass: "text-xs-center auth-img-wrapper"
  }, [_c('img', {
    attrs: {
      "width": "70%",
      "src": "/static/images/new_login_img.svg",
      "alt": ""
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "auth-card-child": "",
      "right-card": "",
      "sign-in-info": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center mt-4"
  }, [_c('h2', [_vm._v("Hello,")]), _vm._v(" "), _c('h2', [_vm._v("welcome back!")])]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-item": "",
      "px-0": ""
    }
  }, [_c('login-input')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b0beaa6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/login.vue
// module id = 1604
// module chunks = 180